"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeUtils = exports.DATE_FORMAT_STRING_TIME_MINUTES = exports.DATE_FORMAT_STRING_DAY_TIME_MILLIS = exports.DATE_FORMAT_STRING_DAY_TIME_SECONDS = exports.DATE_FORMAT_STRING_DAY_TIME_MINUTES = exports.DATE_FORMAT_STRING_DAY = exports.DAY_MILLIS = exports.DAY_SECONDS = exports.HOUR_MILLIS = exports.MINUTE_MILLIS = exports.SECOND_MILLIS = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
moment_timezone_1.default.locale("en");
moment_timezone_1.default.tz.setDefault("UTC");
exports.SECOND_MILLIS = 1000;
exports.MINUTE_MILLIS = 60 * exports.SECOND_MILLIS;
exports.HOUR_MILLIS = 60 * exports.MINUTE_MILLIS;
exports.DAY_SECONDS = 24 * 60 * 60;
exports.DAY_MILLIS = exports.DAY_SECONDS * 1000;
exports.DATE_FORMAT_STRING_DAY = "YYYY/MM/DD";
exports.DATE_FORMAT_STRING_DAY_TIME_MINUTES = "YYYY/MM/DD hh:mm a";
exports.DATE_FORMAT_STRING_DAY_TIME_SECONDS = "YYYY/MM/DD hh:mm:ss a";
exports.DATE_FORMAT_STRING_DAY_TIME_MILLIS = "YYYY/MM/DD hh:mm:ss.SSS a";
exports.DATE_FORMAT_STRING_TIME_MINUTES = "hh:mm a";
const getDayHourMinSec = (millis) => {
    const days = Math.floor(millis / exports.DAY_MILLIS);
    const millisFromDayStart = millis % exports.DAY_MILLIS;
    const secondsFromDayStart = millisFromDayStart / 1000;
    const hours = Math.floor(secondsFromDayStart / 3600);
    const minutes = Math.floor((secondsFromDayStart % 3600) / 60);
    const seconds = Math.floor(secondsFromDayStart % 60);
    return {
        days,
        hours,
        minutes,
        seconds
    };
};
const getDifferenceBetweenMillis = (fromMillis, toMillis) => {
    const diffMilliseconds = toMillis - fromMillis;
    const diffSeconds = Math.floor(diffMilliseconds / 1000);
    const diffDays = Math.floor(diffMilliseconds / exports.DAY_MILLIS);
    const diffHours = Math.floor(diffMilliseconds % exports.DAY_MILLIS / exports.HOUR_MILLIS);
    const diffMinutes = Math.floor((diffMilliseconds % exports.DAY_MILLIS % exports.HOUR_MILLIS) / 60000);
    return {
        milliseconds: diffMilliseconds,
        seconds: diffSeconds,
        minutes: diffMinutes,
        hours: diffHours,
        days: diffDays
    };
};
const formatDifferencesBetweenToMillis = (diff) => {
    const result = [];
    if (diff.days > 0) {
        if (diff.days == 1) {
            result.push(`${diff.days} day`);
        }
        else {
            result.push(`${diff.days} days`);
        }
    }
    if (diff.hours > 0) {
        if (diff.hours == 1) {
            result.push(`${diff.hours} hour`);
        }
        else {
            result.push(`${diff.hours} hours`);
        }
    }
    if (diff.minutes > 0) {
        if (diff.minutes == 1) {
            result.push(`${diff.minutes} minute`);
        }
        else {
            result.push(`${diff.minutes} minutes`);
        }
    }
    if (result.length == 0 && diff.seconds > 0) {
        if (diff.seconds == 1) {
            result.push(`${diff.seconds} second`);
        }
        else {
            result.push(`${diff.seconds} seconds`);
        }
    }
    return result.join(" ");
};
const getStartOfDayMilliseconds = (timeMillis) => timeMillis - (timeMillis % exports.DAY_MILLIS);
const getStartOfTodayMilliseconds = () => getStartOfDayMilliseconds(now());
const getMillisecondsFromDayStart = (timeMillis) => Math.floor(timeMillis % exports.DAY_MILLIS);
const getStartOfDayMillisecondsByShiftFromToday = (shiftByDays) => exports.DateTimeUtils.getMomentFromCurrentTime().startOf("day").subtract(shiftByDays, "day").valueOf();
const formatDate = (timeMillis, type, toLocalTime = false) => {
    switch (type) {
        case "day":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).format(exports.DATE_FORMAT_STRING_DAY);
        case "dayTimeMinutes":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).format(exports.DATE_FORMAT_STRING_DAY_TIME_MINUTES);
        case "dayTimeSeconds":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).format(exports.DATE_FORMAT_STRING_DAY_TIME_SECONDS);
        case "dayTimeMilliseconds":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).format(exports.DATE_FORMAT_STRING_DAY_TIME_MILLIS);
        case "timeOnly":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).format(exports.DATE_FORMAT_STRING_TIME_MINUTES);
        case "ago":
            return (0, moment_timezone_1.default)(timeMillis).local(!toLocalTime).fromNow();
    }
};
const formatUTCZone = (timeMillis) => {
    return (0, moment_timezone_1.default)(timeMillis).local(false).format("Z");
};
const now = () => new Date().getTime();
const isToday = (timeMillis) => getStartOfDayMilliseconds(timeMillis) == getStartOfTodayMilliseconds();
const currentUTCZone = formatUTCZone(now());
exports.DateTimeUtils = {
    now: now,
    getMomentFromMillis: (timeMillis) => (0, moment_timezone_1.default)(timeMillis),
    getMomentFromCurrentTime: () => (0, moment_timezone_1.default)(),
    formatDateAgo: (timeMillis) => (0, moment_timezone_1.default)(timeMillis).fromNow(),
    formatDate: formatDate,
    currentUTCZone: currentUTCZone,
    formatUTCZone: formatUTCZone,
    getDifferenceBetweenMillis: getDifferenceBetweenMillis,
    formatDifferencesBetweenToMillis: formatDifferencesBetweenToMillis,
    getDayHourMinSec: getDayHourMinSec,
    getStartOfDayMilliseconds: getStartOfDayMilliseconds,
    getStartOfTodayMilliseconds: getStartOfTodayMilliseconds,
    getMillisecondsFromDayStart: getMillisecondsFromDayStart,
    getStartOfDayMillisecondsByShiftFromToday: getStartOfDayMillisecondsByShiftFromToday,
    isToday: isToday,
};
